import { useEffect, useState } from "react";
import { useDesignerStore } from "../store";
import { designerEngine } from "../engine/DesignerEngine";

const FONTS = [
  "Arial", "Helvetica", "Georgia", "Times New Roman", "Courier New",
  "Verdana", "Tahoma", "Trebuchet MS", "Impact", "Comic Sans MS",
];
const toHex = (c: any) => (typeof c === "string" && /^#[0-9a-f]{6}$/i.test(c) ? c : "#000000");

// Font / size / colour / bold / italic for the selected text object. Shown in
// both the Text tab and the Properties panel.
export default function TextControls() {
  const selectedObject = useDesignerStore((s) => s.selectedObject);
  const isText = selectedObject?.type === "i-text";

  const [font, setFont] = useState("Arial");
  const [size, setSize] = useState(42);
  const [fill, setFill] = useState("#000000");
  const [bold, setBold] = useState(false);
  const [italic, setItalic] = useState(false);

  useEffect(() => {
    if (selectedObject?.type === "i-text") {
      setFont(selectedObject.fontFamily || "Arial");
      setSize(Math.round(selectedObject.fontSize || 42));
      setFill(toHex(selectedObject.fill));
      setBold(selectedObject.fontWeight === "bold");
      setItalic(selectedObject.fontStyle === "italic");
    }
  }, [selectedObject]);

  if (!isText) {
    return (
      <p className="text-slate-400 text-xs">
        Add text, then select it on the shirt to change its font, size and colour.
      </p>
    );
  }

  return (
    <div className="space-y-3">
      <label className="block text-sm text-slate-300">
        Font
        <select
          value={font}
          onChange={(e) => { setFont(e.target.value); designerEngine.setFontFamily(e.target.value); }}
          className="mt-1 w-full rounded-lg bg-[#0b111c] border border-slate-600 px-3 py-2 text-white"
        >
          {FONTS.map((f) => (
            <option key={f} value={f} style={{ fontFamily: f }}>{f}</option>
          ))}
        </select>
      </label>

      <div className="flex gap-3">
        <label className="text-sm text-slate-300 flex-1">
          Size
          <input
            type="number"
            min={6}
            max={400}
            value={size}
            onChange={(e) => { const v = Number(e.target.value) || 42; setSize(v); designerEngine.setFontSize(v); }}
            className="mt-1 w-full rounded-lg bg-[#0b111c] border border-slate-600 px-3 py-2 text-white"
          />
        </label>
        <label className="text-sm text-slate-300">
          Colour
          <input
            type="color"
            value={fill}
            onChange={(e) => { setFill(e.target.value); designerEngine.setFillColor(e.target.value); }}
            className="mt-1 block h-10 w-14 rounded bg-transparent border border-slate-600 cursor-pointer"
          />
        </label>
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => { setBold(!bold); designerEngine.toggleBold(); }}
          className={`flex-1 rounded-lg py-2 font-bold transition ${bold ? "bg-cyan-600 text-white" : "bg-slate-600 text-white hover:bg-slate-500"}`}
        >
          B
        </button>
        <button
          onClick={() => { setItalic(!italic); designerEngine.toggleItalic(); }}
          className={`flex-1 rounded-lg py-2 italic transition ${italic ? "bg-cyan-600 text-white" : "bg-slate-600 text-white hover:bg-slate-500"}`}
        >
          I
        </button>
      </div>
    </div>
  );
}
